import { JSONController, URLData } from '@telia-common-components/shared';
import * as React from 'react';
import { AddressEventsContext } from './AddressEventsContext';
class AddressEventsProvider extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { events: [] };
        this.jsonController = new JSONController();
        this.urlData = new URLData({ app: this.props.app, tier: this.props.tier });
        this.status = 'UNINITIALIZED';
        this.handleAddressEventsResponse = (response) => this.setState({
            events: response
        });
        this.getAddressEvents = async (props) => {
            if (!props.params) {
                this.setState({ events: [] });
                return;
            }
            const { addressId, buildingId, roomId } = props.params;
            this.status = 'FETCHING';
            try {
                const response = await this.jsonController.fetch(this.urlData.getAddressEventsURL(addressId, buildingId, roomId), { withCredentials: true });
                this.status = 'FETCHED';
                this.handleAddressEventsResponse(response);
            }
            catch (e) {
                this.status = 'ERROR';
                this.setState({ events: [] });
                console.error(e);
            }
        };
        this.getNewAddressEventUrl = () => {
            if (!this.props.params) {
                return null;
            }
            const { addressId, buildingId, roomId, addressText, roomText } = this.props.params;
            return this.urlData.getNewAddressEventUrl(addressId, buildingId, addressText, roomId, roomText);
        };
    }
    static getDerivedStateFromProps(props) {
        const { params } = props;
        if (!params) {
            return { events: [] };
        }
        return null;
    }
    componentDidMount() {
        this.getAddressEvents(this.props);
    }
    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.getAddressIds(prevProps.params)) !== JSON.stringify(this.getAddressIds(this.props.params))) {
            this.getAddressEvents(this.props);
        }
    }
    componentWillUnmount() {
        this.setState = () => {
            return;
        };
    }
    getAddressIds(params) {
        return (params && {
            addressId: params.addressId,
            roomId: params.roomId,
            buildingId: params.buildingId
        });
    }
    render() {
        const { children } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(AddressEventsContext.Provider, { value: {
                    addressEvents: this.state.events,
                    newAddressEventUrl: this.getNewAddressEventUrl(),
                    status: this.status
                } }, children)));
    }
}
export { AddressEventsProvider };
